<template>
  <van-popup
    v-model="visible"
    position="right"
    :style="{ height: '100%', width: '90%' }"
  >
    <div class="hd-title">添加房间</div>
    <div class="pop-box">
      <van-cell-group class="room-info">
        <van-cell>
          <DateRangePicker
            :min="form.isHourRoom ? user.AccountDate : ''"
            :max="max"
            :value.sync="form.daterange"
            :prop="dateProp"
            :disabled="form.disabled"
            :limitMaxDate="
              isHourRoom && form && form.daterange
                ? moment(form.daterange[0] || '')
                    .add(1, 'd')
                    .format('YYYY-MM-DD')
                : ''
            "
            @change="handleDateRange"
          ></DateRangePicker>
        </van-cell>
        <form-select
          label="房型"
          v-model="form.roomTypeId"
          :columns="selectData.roomTypeData"
          @change="data => handleRoomType(data)"
        ></form-select>
        <van-field
          :value="form.number"
          label="房数"
          type="digit"
          placeholder="请输入房数"
          :min="1"
          @change="onChangeNumber"
        />

        <formMultiple
          v-model="form.roomNos"
          label="房号"
          :columns="form.roomNoList"
          textField="No"
          :max="maxRoomNos"
          @click="onSelectRoomNo"
        ></formMultiple>
        <van-field
          type="number"
          :value="form.price"
          label="房费"
          placeholder="请输入房费"
        />
        <form-select
          label="价构"
          v-model="form.priceStructure"
          :columns="selectData.priceStructureData"
          @change="data => handlePriceStructure(data)"
        ></form-select>
      </van-cell-group>
    </div>
    <div class="popup-footer-buttons">
      <van-button type="default" @click="onCancel">取消</van-button>
      <van-button type="info" @click="onSubmit">确认</van-button>
    </div>
  </van-popup>
</template>

<script>
import { Popup, Field, Button, CellGroup, Cell, Notify, Toast } from "vant";
import cloneDeep from "lodash/cloneDeep";
import DateRangePicker from "@/components/date-range-picker/DateRangePicker.vue";
import moment from "moment";
import formSelect from "@/components/form-select";
import roomApi from "@/api/room.js";
import { mapState } from "vuex";
import formMultiple from "@/components/formMultiple";
import calc from "@/utils/calc.js";
export default {
  name: "AddRoomPup",
  components: {
    DateRangePicker,
    formSelect,
    formMultiple,
    [Button.name]: Button,
    [Popup.name]: Popup,
    [Field.name]: Field,
    [CellGroup.name]: CellGroup,
    [Cell.name]: Cell,
  },
  props: {
    defaultItem: {
      type: Object,
      default: () => {},
    },
    isHourRoom: {
      type: Boolean,
      default: false,
    },
    max: {
      type: String,
      default: "",
    },
    pricecodeId: {
      type: [String, Number],
      default: "",
    },
    actionType: {
      type: String,
      default: "order",
    },
  },
  computed: {
    ...mapState({
      user: state => state.user.info,
    }),
  },
  data() {
    return {
      dateProp: {
        startLabel: "预住",
        endLabel: "预离",
        seperate: false,
      },
      moment,
      visible: false,
      info: {},
      data: [],
      selectData: {},
      form: { number: 1 },
      gridData: [],
      maxRoomNos: 1,
    };
  },
  created: function() {},
  mounted() {},

  methods: {
    onShow(info, gridData, selectData) {
      this.info = cloneDeep(info);
      this.form = this.info;
      this.form.number = 1;
      this.maxRoomNos = 1;
      this.selectData = selectData;
      this.gridData = cloneDeep(gridData);
      this.visible = true;
      this.data = [];
    },
    handleDateRange(data, status) {
      const _this = this;
      if (this.isHourRoom && status == "start") {
        const end1 = moment(data[0])
          .add(1, "d")
          .format("YYYY-MM-DD");
        this.form.daterange = [data[0], end1];
        this.form.baseDaterange = [data[0], end1];
      } else if (data[0].valueOf() >= data[1].valueOf() && status == "start") {
        const end1 = moment(data[0])
          .add(1, "d")
          .format("YYYY-MM-DD");
        this.form.daterange = [data[0], end1];
        this.form.baseDaterange = [data[0], end1];
      } else {
        this.form.baseDaterange = cloneDeep(this.form.daterange);
      }
      _this.getRoomNos();
    },
    handleRoomType(data) {
      if (data) {
        if (data.Id == this.form.roomTypeId) {
          return;
        }
        this.form.roomTypeId = data.Id;
        this.form.roomTypeName = data.Text;
        this.getRoomNos();
      } else {
        this.form.roomTypeName = "";
        this.form.roomNo = "";
        this.form.roomId = "";
        this.form.roomNoList = [];
      }
    },
    onSelectRoomNo() {
      if (!(this.form.roomNoList && this.form.roomNoList.length)) {
        Toast("当前房型下暂无可用房间");
      }
    },
    getRoomNos() {
      const { form, info } = this;
      let inTime = info.inTime ? info.inTime : this.defaultItem.ArrivalsTime;
      let outTime = info.outTime
        ? info.outTime
        : this.defaultItem.DepartureTime;
      if (this.isHourRoom) {
        inTime = "";
        outTime = "";
      }
      if (form.roomTypeId) {
        const params = {
          CheckInTime: form.daterange[0] + " " + inTime,
          CheckOutTime: form.daterange[1] + " " + outTime,
          RoomTypeId: form.roomTypeId,
        };
        params.FilterRoomNos = this.filterRoomNo(this.gridData);
        roomApi.GetRoomAvailable(params).then(res => {
          form.roomNoList = res.Data.RoomNos || [];
          if (!(res.Data.RoomNos && res.Data.RoomNos.length)) {
            Toast("当前房型下暂无可用房间");
          }
        });
        this.onGetRoomPrice();
      }
    },
    //过滤不可用房号
    filterRoomNo(obj) {
      const result = [];
      obj.forEach(v => {
        let prop = {
          CheckInTime: v.daterange[0],
          CheckOutTime: v.daterange[1],
          RoomNo: v.roomNo,
        };

        result.push(prop);
      });
      return result;
    },
    onGetRoomPrice() {
      const { form } = this;
      const params = {
        CheckInDate: form.daterange[0],
        CheckOutDate: form.daterange[1],
        RoomTypeId: form.roomTypeId,
        PriceCodeId: this.pricecodeId,
      };
      if (form.roomTypeId > 0 && this.pricecodeId > 0) {
        roomApi.GetRoomPrice(params).then(res => {
          let data = res.Data;
          const price = data.length ? data[0].Price : 0;
          let result = this.selectData.priceStructureData.find(
            price => form.priceStructure && price.Id == form.priceStructure,
          );
          this.form.basePrice = price;
          const addPrice =
            result && result.Data && result.Data.Attribute === 1
              ? result.Data.Price
              : 0;
          this.form.price = calc(price)
            .add(addPrice)
            .number(2);
          this.form.TransactionPrices = data.map(v => {
            if (Number(addPrice) > 0) {
              v.Price = calc(v.Price)
                .add(addPrice)
                .number(2);
            }
            v.PriceDate = v.Date;
            return v;
          });
        });
      }
    },
    handlePriceStructure(data) {
      let result = this.selectData.priceStructureData.find(
        price => data && price.Id == data.Id && data.Data.Attribute === 1,
      );
      const addPrice = result && result.Data ? result.Data.Price : 0;
      if (result && data && Number(addPrice) > 0) {
        this.form.price = calc(this.form.price)
          .add(addPrice)
          .number(2);
      } else {
        this.form.price = this.form.basePrice;
      }
    },
    onChangeNumber(e) {
      this.maxRoomNos = e.target.value;
      this.form.number = this.maxRoomNos;
    },
    onCancel() {
      this.visible = false;
    },
    onSubmit() {
      const { form, info } = this;
      if (!form.roomTypeId) {
        Notify("请选择房型");
        return;
      }
      const obj = {};
      form.roomNoList.forEach(el => {
        obj[el.Id] = el;
      });
      let list = [];
      for (let i = 0; i < form.number; i++) {
        let roomNo = "",
          roomId = "";
        if (form.roomNos && form.roomNos[i]) {
          roomNo = (obj[form.roomNos[i]] || {}).No;
          roomId = form.roomNos[i];
        }
        const daliyPrices = (form.TransactionPrices || []).map(v => {
          v.Price = form.price;
          v.RoomNo = roomNo;
          return v;
        });
        const item = {
          daterange: form.daterange,
          inTime: info.inTime,
          outTime: info.outTime,
          baseDaterange: form.daterange,
          days: moment(form.daterange[1]).diff(moment(form.daterange[0]), "d"),
          price: form.price,
          roomTypeId: form.roomTypeId,
          roomTypeName: form.roomTypeName,
          roomId: roomId || "",
          roomNo: roomNo,
          roomNoList: form.roomNoList,
          TransactionPrices: daliyPrices,
          BaseTransactionPrices: cloneDeep(daliyPrices),
          Persons: [],
          OrderStatus: info.OrderStatus,
          priceStructure: form.priceStructure,
          disabled: info.disabled,
          isNew: true,
        };
        list.push(item);
      }
      this.visible = false;
      this.$emit("submit", list);
    },
  },
};
</script>

<style lang="less" scoped>
.hd-title {
  padding-top: 16px;
  font-weight: normal;
  text-align: center;
  font-size: 16px;
  padding-bottom: 13px;
  background: #f6f6f6;
}
.pop-box {
  height: calc(100vh - 94px);
  overflow-y: auto;
  position: relative;
}
.popup-footer-buttons {
  display: flex;
  button {
    flex: 1;
  }
}
</style>
